import { Link } from "react-router-dom";
import coelhoLogo from "../../../assets/images/coelho/logo-header.png";
import { useBreakpoints } from "../../../hooks/useBreakpoins";
import { Box } from "@mui/material";

export function Logo({ onClick }: { onClick?: VoidFunction }) {
  const { isSmalldesktop } = useBreakpoints();

  return (
    <Link
      to={`/home`}
      rel="noopener noreferrer"
      style={{ textDecoration: "none", color: "inherit", zIndex: 23123232323 }}
    >
      <Box
        sx={{
          "&:hover": { opacity: 0.5, transition: "200ms ease-in-out" },
          "&:not(:hover)": { transition: "200ms ease-in-out" },
        }}
      >
        <img
          src={coelhoLogo}
          width={isSmalldesktop ? 100 : 144}
          alt="treasurebox logo"
          style={{
            marginTop: 5,
            marginLeft: 15,
            paddingTop: 3,
            paddingBottom: 3,
            cursor: "pointer",
          }}
          onClick={() => {
            onClick && onClick();
          }}
        />
      </Box>
    </Link>
  );
}
